import { Layout } from '../../components/layout';
import { Content, ContentSearch, ContentTopic, LeftSidebar, RightSidebar } from './components';
import './Dashboard.styles.css';
import { useSearchParams } from 'react-router-dom';
import { ActionBar } from './components/action-bar';
import { useEffect } from 'react';

export default function Dashboard() {
  const [searchParams] = useSearchParams();
  const searchParamsSearch = searchParams.get('searchTerm');
  const searchParamsTypes = searchParams.get('types');
  const searchParamsTopic = searchParams.get('topicId');
  const searchParamsUnit = searchParams.get('unitInChargeIds');
  const showLatest =
    !searchParamsSearch && !searchParamsTypes && !searchParamsTopic && !searchParamsUnit;
  const showTopic =
    !searchParamsSearch && !searchParamsTypes && Boolean(searchParamsTopic) && !searchParamsUnit;
  const showSearch = !showLatest && !showTopic;

  useEffect(() => {
    document.title = 'GI Arbeitsgrundlagen';
  }, []);

  return (
    <Layout leftSidebar={<LeftSidebar />} rightSidebar={<RightSidebar />}>
      <>
        <ActionBar />
        {showLatest && <Content />}
        {showTopic && <ContentTopic />}
        {showSearch && <ContentSearch />}
      </>
    </Layout>
  );
}
